import { ReferentialKey } from "api/referential";
import { ComponentKey } from "enums/componentKey";
import { BaseLegalEntityFormFieldNames } from "shared/enums/baseLegalEntityFormFieldNames";
import { InputsConfig } from "types/form/inputsConfig";

export const baseLegalEntityInputsConfig: InputsConfig<BaseLegalEntityFormFieldNames> =
{
  [BaseLegalEntityFormFieldNames.LegalReason]: {
    componentKey: ComponentKey.ReferentialDropdown,
    referentialKey: ReferentialKey.LegalForm,
    name: BaseLegalEntityFormFieldNames.LegalReason,
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.LABELS.LEGAL_REASON',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.PLACEHOLDERS.LEGAL_REASON'
  },
  [BaseLegalEntityFormFieldNames.RegistrationNumber]: {
    componentKey: ComponentKey.InputText,
    name: BaseLegalEntityFormFieldNames.RegistrationNumber,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.LABELS.REGISTRATION_NUMBER',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.PLACEHOLDERS.REGISTRATION_NUMBER'
  },
  [BaseLegalEntityFormFieldNames.RcsNumber]: {
    componentKey: ComponentKey.InputText,
    name: BaseLegalEntityFormFieldNames.RcsNumber,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.LABELS.RCS_NUMBER',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.PLACEHOLDERS.RCS_NUMBER'
  },
  [BaseLegalEntityFormFieldNames.RcsCity]: {
    componentKey: ComponentKey.InputText,
    name: BaseLegalEntityFormFieldNames.RcsCity,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.LABELS.RCS_CITY',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.PLACEHOLDERS.RCS_CITY'
  },
  [BaseLegalEntityFormFieldNames.Capital]: {
    componentKey: ComponentKey.InputText,
    name: BaseLegalEntityFormFieldNames.Capital,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.LEGAL_ENTITY.LABELS.CAPITAL',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.PLACEHOLDERS.CAPITAL'
  },
  [BaseLegalEntityFormFieldNames.OriasNumber]: {
    componentKey: ComponentKey.InputText,
    name: BaseLegalEntityFormFieldNames.OriasNumber,
    type: 'text',
    required: false,
    label: 'ACTOR_FORM.LEGAL_ENTITY.LABELS.ORIAS_NUMBER',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.PLACEHOLDERS.ORIAS_NUMBER'
  },
  [BaseLegalEntityFormFieldNames.Rcp]: {
    componentKey: ComponentKey.InputText,
    name: BaseLegalEntityFormFieldNames.Rcp,
    type: 'text',
    required: false,
    label: 'ACTOR_FORM.LEGAL_ENTITY.LABELS.RCP',
    placeholder: 'ACTOR_FORM.LEGAL_ENTITY.PLACEHOLDERS.RCP'
  },
};
